let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("8ZxYb")).then(() => parcelRequire('jP6KQ'));